import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { loadHelloVideo } from './helloVideoLoader';
import HelloVideoModal from './HelloVideoModal';
import css from './HelloVideo.module.css';

// Play badge on a listener photo — tap/click to play, no hover (Sam, Oct 26).
// Renders nothing unless the listener has an approved hello video.
const HelloPlayBadge = ({ userId, name, size = 'md', className }) => {
  const [video, setVideo] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let live = true;
    loadHelloVideo(userId).then(v => live && setVideo(v));
    return () => {
      live = false;
    };
  }, [userId]);

  if (!video) return null;
  return (
    <>
      <button
        type="button"
        className={classNames(css.playBadge, css[`playBadge_${size}`], className)}
        aria-label={`Play ${name ? `${name}’s` : 'the'} hello video`}
        title="Watch hello video"
        data-hello-play-badge="true"
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          setOpen(true);
        }}
      >
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6.5v11l9-5.5z" fill="currentColor" /></svg>
        {size === 'chip' ? <span>Hello</span> : null}
      </button>
      {size === 'lg' ? <span className={css.videoPill} aria-hidden="true">▶ Video intro</span> : null}
      {open ? <HelloVideoModal video={video} name={name} onClose={() => setOpen(false)} /> : null}
    </>
  );
};

export default HelloPlayBadge;
